import { Filter, Interval } from '@elderbyte/ngx-starter'

export class FilterBuilder {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public static readonly FACILITY_KEY = 'facility'

  /***************************************************************************
   *                                                                         *
   * Static Builders                                                         *
   *                                                                         *
   **************************************************************************/

  public static facility(facility: string): Filter {
    return new Filter(FilterBuilder.FACILITY_KEY, facility)
  }

  public static scheduleInterval(interval: Interval): Filter {
    return new Filter('scheduleInterval', interval.toInstantString())
  }

  public static ids(ids: string[]): Filter {
    return new Filter('ids', ids)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/
}
